import milanoConfig from './agenzia-milano/config.json';
import romaConfig from './agenzia-roma/config.json';
import agency1Config from './agency1/config.json';
export const agencyConfigs = [
    milanoConfig,
    romaConfig,
    agency1Config,
];
